module.exports = __webpack_public_path__ + "static/media/devilAngry.dd65b478.png";